import { Component } from '@angular/core';

@Component({
  selector: 'app-pharmacy-icon',
  imports: [],
  templateUrl: './pharmacy-icon.html',
  styleUrl: './pharmacy-icon.scss',
})
export class PharmacyIcon {

}
